import { render, staticRenderFns } from "./MainAs.vue?vue&type=template&id=53b683da&scoped=true"
import script from "./MainAs.vue?vue&type=script&lang=js"
export * from "./MainAs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b683da",
  null
  
)

export default component.exports